var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E3B49",
    d: "M24.533 11.259h-9.6c-0.356 0-0.593-0.237-0.593-0.593s0.237-0.593 0.593-0.593h9.6c0.356 0 0.593 0.237 0.593 0.593s-0.237 0.593-0.593 0.593zM10.667 11.259h-3.2c-0.356 0-0.593-0.237-0.593-0.593s0.237-0.593 0.593-0.593h3.2c0.356 0 0.593 0.237 0.593 0.593s-0.237 0.593-0.593 0.593z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E3B49",
    d: "M24.533 21.926h-3.2c-0.356 0-0.593-0.237-0.593-0.593s0.237-0.593 0.593-0.593h3.2c0.356 0 0.593 0.237 0.593 0.593s-0.237 0.593-0.593 0.593zM17.067 21.926h-9.6c-0.356 0-0.593-0.237-0.593-0.593s0.237-0.593 0.593-0.593h9.6c0.356 0 0.593 0.237 0.593 0.593s-0.237 0.593-0.593 0.593z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E3B49",
    d: "M24.533 16.593h-17.067c-0.356 0-0.593-0.237-0.593-0.593s0.237-0.593 0.593-0.593h17.067c0.356 0 0.593 0.237 0.593 0.593s-0.237 0.593-0.593 0.593z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.0d2d96a6cbd6cb0bb91b03c15c36d182.svg";
export { ForwardRef as ReactComponent };